export const userPl = {
  user: {
    guest: 'Gość',
    menu: {
      title: 'Menu użytkownika',
    },
    avatar: {
      alt: 'Avatar użytkownika',
      guestAlt: 'Avatar gościa',
    },
    profile: {
      title: 'Profil',
      edit_button: 'Edytuj Profil',
      subtitle: 'Twoje publiczne informacje i szczegóły konta.',
      user_id_label: 'ID Użytkownika',
      no_profile: 'Brak danych profilu',
      auth_required_title: 'Wymagane logowanie',
      auth_required_message: 'Zaloguj się aby korzystać z wszystkich funkcji aplikacji',
      login_button: 'Zaloguj się',
      register_button: 'Załóż konto',
    },
    edit: {
      title: 'Edytuj Profil',
      subtitle: 'Zaktualizuj swoje imię, email i avatar.',
      name_label: 'Imię',
      name_placeholder: 'Wprowadź swoje imię',
      name_required: 'Imię jest wymagane',
      email_label: 'Email',
      email_placeholder: 'Wprowadź swój email',
      email_invalid: 'Nieprawidłowy adres email',
      avatar_label: 'URL Avatara',
      avatar_placeholder: 'https://www.gravatar.com/avatar/...',
      avatar_invalid: 'URL avatara musi pochodzić z dozwolonego dostawcy (np. Gravatar)',
      avatar_help: 'Dozwolone są tylko URL-e z zaufanych dostawców takich jak Gravatar',
      generate_gravatar: 'Wygeneruj URL Gravatar z adresu email',
      email_required_for_gravatar: 'Email jest wymagany do wygenerowania URL Gravatar',
      gravatar_generated: 'URL Gravatar wygenerowany',
      gravatar_generation_failed: 'Nie udało się wygenerować URL Gravatar',
      cancel: 'Anuluj',
      save_changes: 'Zapisz Zmiany',
      show_public_profile: 'Pokaż Profil Publiczny',
    },
    publicProfile: {
      not_found: 'Profil użytkownika nie został znaleziony',
      not_public: 'Ten profil użytkownika nie jest publiczny',
      error: 'Nie udało się załadować profilu użytkownika',
      error_title: 'Profil Niedostępny',
      public_containers: 'Kontenery publiczne',
      no_containers: 'Brak publicznych kontenerów',
      no_containers_description: 'Ten użytkownik nie udostępnił jeszcze żadnych publicznych kontenerów',
    },
    roles: {
      admin: 'Administrator',
      owner: 'Właściciel',
      premium: 'Premium',
    },
  },
}

